<template>
    <div class="integralTicketDetailsBox">
        <!--<div class="memberRuleNav">-->
            <!--<i @click="returnFn" class="iconfont iconzuojiantou"></i>-->
        <!--</div>-->
        <div class="scrollDetails">
            <div class="scrollDetailsBox">
                <div class="itemRow">
                    <div class="integralTitle">电子券名称</div>
                    <div class="integralContent">200面额券</div>
                </div>
                <div class="itemRow">
                    <div class="integralTitle">电子券批次号</div>
                    <div class="integralContent">00000000199</div>
                </div>
                <div class="itemRow">
                    <div class="integralTitle">扣减积分</div>
                    <div class="integralContent">1000</div>
                </div>
                <div class="itemRow">
                    <div class="integralTitle">领取数量</div>
                    <div class="integralContent">1</div>
                </div>
                <div class="itemRow">
                    <div class="integralTitle">兑换时间</div>
                    <div class="integralContent">2019-10-15 14:44:45</div>
                </div>
                <div class="itemRow">
                    <div class="integralTitle">领取时间</div>
                    <div class="integralContent">2019-10-16 15:55:06</div>
                </div>

                <div class="textRow">
                    <div class="textL">领奖说明：</div>
                    <div class="textR">领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明领奖说明</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "integralTicketDetails",
        mounted() {
            document.title = "换券详情"
        },
        methods:{
            // returnFn(){
            //     this.$router.go(-1)
            // }
        }
    }
</script>

<style lang="scss" scoped>
.integralTicketDetailsBox{
    position: relative;
    width: 100%;
    height: 100%;
    /*.memberRuleNav{*/
        /*width: 100%;*/
        /*height: 45px;*/
        /*background-color: #6cf;*/
        /*box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);*/
        /*line-height: 45px;*/
    /*}*/
    /*.iconzuojiantou{*/
        /*font-size: 24px;*/
        /*color: #fff;*/
        /*margin-left: 4px;*/
        /*padding: 6px;*/
    /*}*/
    .scrollDetails{
        position: absolute;
        /*top: 45px;*/
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .scrollDetailsBox{
        padding-top: 10px;
        width: 90%;
    }
    .itemRow{
        width: 100%;
        display: flex;
        height: 32px;
    }
    .integralTitle{
        flex: 1;
        line-height: 32px;
        color: #888;
    }
    .integralContent{
        flex: 2;
        line-height: 32px;
        color: #333;
    }
    .textRow{
        margin-top: 20px;
        width: 100%;
        display: flex;
        border: 1px solid #2db7f5;
        padding: 5px;
        font-size: 14px;
        box-sizing: border-box;
    }
    .textL{
        flex: 2;
        color: #666;
    }
    .textR{
        color: #333;
        flex: 5;
    }
}
</style>
